<div class="modal-content">
  <div class="modal-header">
    <h2 class="modal-title h4">{{ 'MODAL_NEW_OFFER.TITLE' | translate }}</h2>
    <button type="button" class="close pull-right" aria-label="Close" (click)="handleClick({ close: true })">
      <i class="fas fa-times"></i>
    </button>
  </div>
  <div class="col-12 mt-2">
    <jhi-bary-offer-form [formGroup]="formGroup"></jhi-bary-offer-form>
    <div class="modal-body text-left mt-2">
      <h5>{{ 'MODAL_NEW_OFFER.NAME.LABEL' | translate }}</h5>
      <jhi-bary-input-text class="pb-1 d-block" [control]="formGroup.controls.name" [placeholder]="'MODAL_NEW_OFFER.NAME.PLACEHOLDER' | translate"></jhi-bary-input-text>
    </div>
    <div class="modal-footer justify-content-end">
      <jhi-bary-button [outline]="true" color="primary" [label]="'BTN.CANCEL' | translate" (clickEvent)="handleClick({ first: true })"></jhi-bary-button>
      <jhi-bary-button (clickEvent)="handleSubmit()" class="ml-2" [disabled]="formGroup.invalid" [label]="'BTN.CONFIRM' | translate" color="primary"></jhi-bary-button>
    </div>
  </div>
</div>
